// @flow
import React, { Component } from 'react';
import TooltipContent from './TooltipContent';
import { DefaultIcon } from './Icon';
import { InfoIconDiv } from './InfoTooltipStyles';
import { connect } from 'react-redux';
import { hideTooltip } from '../App/reducer';

type Props = {
  showTooltip: (tooltip: string) => void,
  hideTooltip: () => void,
  activeTooltip: ?string,
  tooltipName: string,
  message: string,
  mobileRightEdge?: boolean,
  iconColor?: string,
  className?: string,
  smallIcon?: boolean,
  icon?: string
};

class InfoTooltip extends Component<Props> {
  static defaultProps = {
    iconColor: 'blue',
    icon: 'infoThick'
  };

  mouseEnter = (event: SyntheticMouseEvent<HTMLDivElement>) => {
    event.stopPropagation();
    this.props.showTooltip(this.props.tooltipName);
  };

  mouseLeave = (event: SyntheticMouseEvent<HTMLDivElement>) => {
    event.stopPropagation();
    this.props.hideTooltip();
  };

  render() {
    return (
      <InfoIconDiv
        className={this.props.className}
        smallIcon={this.props.smallIcon}
        onMouseEnter={this.mouseEnter}
        onMouseLeave={this.mouseLeave}
      >
        {this.props.activeTooltip === this.props.tooltipName && (
          <TooltipContent
            message={this.props.message}
            mobileRightEdge={this.props.mobileRightEdge}
          />
        )}
        <DefaultIcon name={this.props.icon} colorName={this.props.iconColor} />
      </InfoIconDiv>
    );
  }
}

const mapDispatchToProps = { hideTooltip };

export default connect(null, mapDispatchToProps)(InfoTooltip);
